import { get, post } from "@/utils/http";

let baseURL = "/offdocument";

let baseURL2 = "/personal";

//发布公文流转
const submitFile = data => post(`${baseURL}/submitFile`, {data})

//保存公文流转
const saveFile = data => post(`${baseURL}/saveFile`, {data})

//查询所有用户信息
const findAllPersonalInfo = () => get(`${baseURL2}/findAllPersonal`)

//查询所有用户信息byUserId
const findAllPersonalByUserId = (data) => get(`${baseURL2}/findAllPersonalByUserId`,data)

// 查询所有公文信息
const findAll = data => post(`${baseURL}/findAll`, {data});

//删除公文
const deleteDocInfo = data => post(`${baseURL}/deleteDoc`, { data });

// 通知未签阅人员
const notice = data => get(`${baseURL}/notice`, data);

// 提交批注
const addComment = data => post(`${baseURL}/addComment`, {data});

// 签阅
const signDoc = data => get(`${baseURL}/signDoc`, data);

// 完成公文
const companyDoc = data => post(`${baseURL}/companyDoc`, {data});

// API
export default {
  submitFile,
  saveFile,
  findAllPersonalInfo,
  findAll,
  deleteDocInfo,
  addComment,
  notice,
  signDoc,
  companyDoc,
  findAllPersonalByUserId
  };